import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  addChangesShowAdminBarCallback,
  removeCb,
  showAdminBar as enableAdminBar,
} from '../../../../show-admin-bar-enable';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnDestroy {
  enableAdminBar = environment.showAdminBar;
  showAdminBar = enableAdminBar;
  private showCb: OmitThisParameter<() => void>;

  constructor(private cdr: ChangeDetectorRef) {
    this.showCb = this.detectShowAdminBar.bind(this);
    addChangesShowAdminBarCallback(this.showCb);
  }

  detectShowAdminBar() {
    this.showAdminBar = enableAdminBar;
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    removeCb(this.showCb);
  }
}
